import "./formik-demo.css";
import React from "react";
//import classNames from "classnames";

const lineStyle = {
	'backgroundColor': '#ddd',
	'padding': '0.3em'
}

const lineStyleClicked = {
	'backgroundColor': '#cfc',
	'padding': '0.3em'
}

const lineStyleFalse = {
	'backgroundColor': '#ddd',
	'padding': '0.3em',
	'border': '1px solid red'
}

const lineStyleClickedFalse = {
	'backgroundColor': '#cfc',
	'padding': '0.3em',
	'border': '1px solid red'
}

const QUESTION_VALUES = [
	{
		question: "In welchen Fahrzeugen muss Ladung gesichert werden?",
		options: [
			{option: "In LKW", correct: true, key: 11},
			{option: "In leichten Nutzfahrzeugen (z.B. Caddy, Sprinter) ", correct: true, key: 12},
			{option: "In PKW", correct: true, key: 13},
			{option: "Nur in Geschäftsfahrzeugen, die auch privat genutzt werden dürfen", correct: false, key: 14},
		]
	},
	{
		question: "Wer ist für die richtige Sicherung der Ladung zu allererst verantwortlich?",
		options: [
			{ option: "Die Leasinggesellschaft" , correct: false, key: 21 },
			{ option: "Der Fahrzeugführer (Fahrer)" , correct: true, key: 22 },
			{ option: "Der Chef", correct: false, key: 23 },
			{ option: "Der Fuhrparkleiter", correct: false, key: 24 }
		]
	},
	{
		question: "Welche Ladung muss gesichert werden?",
		options: [
			{ option: "Größere Ladungen, z.B. Boxen" , correct: true, key: 31 },
			{ option: "Kleinere Ladung, z.B. Aktenkoffer", correct: true, key: 32 },
			{ option: "Nur leichte Ladung, weil die schwere Ladung ja sicher steht", correct: false, key: 33 },
			{ option: "Nur geschäftliche Ladung, z.B. Warenmuster", correct: false, key: 34 }
		]
	},
	{
		question: "In welche Richtung muss die Ladung gesichert werden?",
		options: [
			{ option: "Nach oben", correct: false, key: 41 },
			{ option: "Nach vorne", correct: true, key: 42 },
			{ option: "Zur Seite", correct: true, key: 43 },
			{ option: "Nach hinten", correct: true, key: 44 }
		]
	}
]

class AntwortLinie extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			clicked: false
		}
	}

	clickMe(e) {
		console.log("clickMe!!!");
		if (this.props.phase === 'antwortphase') {
			this.setState({clicked: !this.state.clicked});
		}
	}

	renderLineStyle() {
		if (this.props.phase === 'antwortphase') {
			if (this.state.clicked) {
				return lineStyleClicked;
			} else {
				return lineStyle;
			}
		} else {
			if (this.state.clicked) {
				if (this.correct()) {
					return lineStyleClicked
				} else {
					return lineStyleClickedFalse;
				}
			} else {
				if (this.correct()) {
					return lineStyle;
				} else {
					return lineStyleFalse;
				}
			}
		}
	}

	correct() {
		return this.props.korrekt === this.state.clicked;
	}

	gutMarkierung() {
		const mark = String.fromCharCode(10003);
		if (this.state.clicked) {
			return (
				<span style={{color:'green'}}> {mark}</span>
			)} else {
				return ""
			}
	}

	schlechtMarkierung() {
		const mark = String.fromCharCode(10060);

		if (this.state.clicked) {
			return (
				<span style={{color:'red'}}> {mark}
					<i>Diese Antwort ist falsch.</i>
				</span>
			)} else {
				return (
				<span style={{color:'red'}}> {mark}
					<i>Diese Antwort wäre richtig gewesen.</i>
				</span>
			)}
	}

	render () {
		return (
			<p className="w-100 p-3"
				style={this.renderLineStyle()}
				onClick={(e) => this.clickMe(e)}>
				<strong>{this.props.antwort}</strong>
				{this.props.phase === 'auswertungsphase' && <span>{(this.props.korrekt === this.state.clicked ) ? this.gutMarkierung() : this.schlechtMarkierung()}</span>}
			</p>
		)
	}
}

// Input feedback
/*
const InputFeedback = ({ error }) =>
  error ? <div className={classNames("input-feedback")}>{error}</div> : null;
*/

class VideoFragen extends React.Component {

	constructor(props) {
    super(props);
		this.state = {
		}
  }

	renderAntwortLines(options) {
		const optionsString = options.map((o, index) =>
			<AntwortLinie
				key={o.key}
				ref={o.key}
				antwort={o.option}
				korrekt={o.correct}
				phase={this.props.phase}
				onClick={(e) => this.clickMe(e)} />
		)
		console.log("optionsString:", optionsString);
		return optionsString;
	}

	hasFalseAnswers() {

		// Ein Array, das am Ende alle Refs (= AntwortLinien) beinhaltet
		const refArray = [];
		for (var k in this.refs) {
			if (this.refs.hasOwnProperty(k)) {
				refArray.push(this.refs[k]);
			}
		}

		const reducer = (accumulator, currentValue) => accumulator + currentValue;

		return refArray.map((r) => r.correct() ? 0 : 1).reduce(reducer);
	}

	render () {

		const bn = this.props.blockNummer;
		const fragenBlock = QUESTION_VALUES[bn];
		console.log(fragenBlock);

		return (
			<React.Fragment>
			  <div className="w-100 pl-3 sol-sm-10 h4">
			    Testen Sie Ihr Wissen! Frage {bn+1} von 4:<br/>{fragenBlock.question}
				</div>
				<div className="w-100 p-3">
					{this.renderAntwortLines(fragenBlock.options)}
				</div>
			</React.Fragment>

		)};
};

export default VideoFragen



// WEBPACK FOOTER //
// ./src/components/video/VideoFragen.js